import { CalendarCheck, CalendarX, CreditCard, House, Phone, Tag, UserRound } from 'lucide-react';
import { formatDisplayDate } from '@/utils/date';
import { getUserFieldLabel } from '../../constants/user.constants';
import type { DetailItemProps } from './DetailItem';
import { ProfileDetailSection } from './ProfileDetailSection';
import type { ProfilePersonalDetails } from './types';

const PERSONAL_SECTION_TITLE = 'Personal Information';

function toDisplayDate(value: string | null | undefined): string | null {
  return value === null || value === undefined ? null : formatDisplayDate(value);
}

interface PersonalSectionProps {
  user: ProfilePersonalDetails | undefined;
}

export function PersonalSection({ user }: PersonalSectionProps) {
  const fields: DetailItemProps[] = [
    { label: getUserFieldLabel('nickname'), value: user?.nickname, icon: Tag, tooltip: null },
    { label: getUserFieldLabel('contactNo'), value: user?.contactNo, icon: Phone, tooltip: null },
    {
      label: getUserFieldLabel('accountNumber'),
      value: user?.accountNumber,
      icon: CreditCard,
      tooltip: null,
    },
    {
      label: getUserFieldLabel('activeFrom'),
      value: toDisplayDate(user?.activeFrom),
      icon: CalendarCheck,
      tooltip: null,
    },
    {
      label: getUserFieldLabel('activeTo'),
      value: toDisplayDate(user?.activeTo),
      icon: CalendarX,
      tooltip: null,
    },
    {
      label: getUserFieldLabel('address'),
      value: user?.address,
      icon: House,
      tooltip: null,
    },
  ];

  return (
    <ProfileDetailSection
      title={PERSONAL_SECTION_TITLE}
      icon={UserRound}
      fields={fields}
      isLoading={user === undefined}
    />
  );
}
